import React, { useState } from "react";
import Alert from '@mui/material/Alert';
import Grid from "@mui/material/Grid";
import TitleBar from "../../../components/TitleBar";
import CloseTripForm2 from "./CloseTripForm2";
import CloseTripForm3 from "./CloseTripForm3";
import Confirm from "./Confirm";

function CloseTripForm1({ tripId, vtr_nbr, permitNbr, returnedErrors, handleSubmit }) {
  const [step, setStep] = useState(1);
  const [portcd, setPortCD] = useState({});
  const [mnkfshOvrFlg, setMnkfshFlg] = useState("false");

  const values = {
    tripid: tripId,
    vtr_nbr,
    permitNbr,
    portcd,
    mnkfshOvrFlg,
    setStep,
  };

  const nextStep = () => {
    setStep(step + 1);
  };

  const prevStep = () => {
    setStep(step - 1);
  };

  const goToStep = (step) => {
    setStep(step);
  };

  const handleChange = (input) => (event, reason) => {
    const { value } = event.target;

    if (input === "port") {
      if (reason) {
        if (reason.hasOwnProperty("id") && reason.hasOwnProperty("label")) {
          setPortCD({ id: reason.id, name: reason.label, state: reason.state });
        }
      } else {
        setPortCD({});
      }
    } else if (input === "mnkfshOvrFlg") setMnkfshFlg(value);
  };

  const handleConfirm = (values) => {
    handleSubmit(values);
  };

  return (
    <>
      <TitleBar title="DAS Close Trip Hail" />
      <Grid item xs={12} md={7}>
        {returnedErrors.onSubmitted && (
          <Alert severity="error">{returnedErrors.onSubmitted}</Alert>
        )}
      </Grid>
      <div style={{ width: "100%" }}>
        {
          {
            1: (
              <CloseTripForm2
                nextStep={nextStep}
                handleChange={handleChange}
                values={values}
              />
            ),
            2: (
              <CloseTripForm3
                prevStep={prevStep}
                nextStep={nextStep}
                handleChange={handleChange}
                values={values}
              />
            ),
            3: (
              <Confirm
                prevStep={prevStep}
                goToStep={goToStep}
                handleConfirm={handleConfirm}
                values={values}
              />
            ),
          }[step]
        }
      </div>
    </>
  );
}

export default CloseTripForm1;
